"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackToAppointmentsRequestStruct = void 0;
const superstruct_1 = require("superstruct");
exports.BackToAppointmentsRequestStruct = (0, superstruct_1.type)({
    placeId: (0, superstruct_1.string)(),
    appointmentId: (0, superstruct_1.string)(),
    startTime: (0, superstruct_1.string)(),
    endTime: (0, superstruct_1.string)(),
    counterId: (0, superstruct_1.optional)((0, superstruct_1.string)()),
});
//# sourceMappingURL=BackToApointmentsRequest.js.map